import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import ArrowLeft from '../../components/Images/ArrowLeft'
// import ChevronDown from '../../components/Images/ChevronDown'
// import ChevronUp from '../../components/Images/ChevronUp'
import EmptyComment from '../../components/Images/EmptyComment'
import Telegram from '../../components/Images/Telegram'
import Loader from '../../components/Loader'
import { get, post } from '../../lib/api'
import { useInfiniteScroll } from '../../lib/customHooks'
import { handleEventLog } from '../../lib/utils'
import WordLimit from './WordLimit'

const Heading = styled.h3`
  font-family: 'Noto Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(13, 21, 54, 0.8);
  padding: 8px 0px 8px 0px;
  display: flex;
  justify-content: space-between;
`
const CommentContainer = styled.div`
  display: flex;
  padding-bottom: 12px;
`
const CommentInfoWrapper = styled.div`
  width: calc(100% - 40px);
  padding-left: 16px;
`
const ImageContainer = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: var(--Dove);
  overflow: hidden;
  box-shadow: inset 0 0 4px 0 var(--storm-op-16);
  transition: all 0.2s;
`
const ProfileImage = styled.img`
  border-radius: inherit;
  width: 100%;
  height: 100%;
`
const CommentorName = styled.p`
  font-family: 'Noto Sans';
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.8);
`
const CommentText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(13, 21, 54, 0.65);
`
const CommentedAgoTimeWrapper = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #aaaaaa;
`
// const ChevronIconContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 15px;
//   align-items: center;
// `
const MobileCommentsContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 3001;
  display: flex;
  flex-direction: column;
  textarea::-webkit-scrollbar {
    display: none;
  }
`
const CommentsWrapper = styled.div`
  width: 100%;
  overflow: scroll;
  padding: 12px;
  padding-bottom: 16px;
`
const MobileHeaderComments = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  background: #f6f7f9;
  border-radius: 16px 16px 0px 0px;
  svg {
    margin-right: 16px;
  }
`
const MobileFooterComments = styled.div`
  padding: 8px 14px;
  width: 100%;
  background: #e1e3ea;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0px;
`
const CommentTextAreaMobile = styled.textarea`
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--Text700);
  border-radius: 24px;
  padding: 8px 16px;
  background: #eff1f8;
  border: none;
  resize: none;
  &:focus {
    outline: none;
    border: solid 2px var(--Azure500);
    background-color: var(--Dove);
  }
`
const CommentTextArea = styled.textarea`
  width: 80%;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  color: var(--Text700);
  min-height: 32px;
  padding: 8px 0px;
  height: 44px;
  border: none;
  border-bottom: 1px solid rgba(13, 21, 54, 0.2);
  resize: none;
  outline: none;
  width: 80%;
  margin-left: 16px;
  &:focus {
    outline: none;
  }
`
const TelegramIconContainer = styled.div`
  padding-left: 12px;
  cursor: pointer;
  align-self: end;
`
const CommentWrapperforDesktop = styled.div`
  display: flex;
  width: 100%;
`

const NoCommentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`
const NoCommentSubTitle = styled.p`
  font-family: 'Noto Sans';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: rgba(13, 21, 54, 0.65);
`
const NoCommentTitle = styled.h3`
  font-family: 'Noto Sans';
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
`

const NoCommentWrapper = styled.div`
  padding: 16px;
`
const DeskTopCommentsContainer = styled.div`
  width: 65%;
`
const httpToHttps = (url) => {
  if (!url.includes('https://')) {
    return url.replace(/^http:\/\//i, 'https://')
  }
  return url
}

const Comment = ({
  comment_creation_time,
  fullname,
  comment,
  profile_image_url,
  keyName,
}) => {
  return (
    <CommentContainer key={{ keyName }}>
      <ImageContainer>
        {profile_image_url && (
          <ProfileImage
            src={httpToHttps(profile_image_url || '')}
            alt="Writer Avator"
          />
        )}
      </ImageContainer>
      <CommentInfoWrapper>
        <CommentorName>
          {fullname || ''}{' '}
          <CommentedAgoTimeWrapper>
            {comment_creation_time}
          </CommentedAgoTimeWrapper>{' '}
        </CommentorName>
        <CommentText>
          {' '}
          <WordLimit content={comment} limit={50} />
        </CommentText>
      </CommentInfoWrapper>
    </CommentContainer>
  )
}

export default function WriterAcademyComments({
  isMobileView,
  isCommentOpen,
  setIsCommentOpen,
  user,
  lessonId,
  totalCommentsCount,
  setTotalCommentsCount,
  handlePostCommentLogoutUser = () => {},
}) {
  const [commentValue, setCommentValue] = useState('')
  const [comments, setComments] = useState([])
  const [textareaheight, setTextareaheight] = useState(1)
  const [pageNumber, setPageNumber] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  // const [totalCommentsCount, setTotalCommentsCount] = useState(null)
  const { fullname, gender, uid, languages, image_url } = user || {}

  const isFetching = useInfiniteScroll(fetchMoreData)
  function fetchMoreData(setIsFetching) {
    if (!pageNumber) {
      setIsFetching(false)
      return
    }
    get(
      `/social/comment.get_academy_comments?lesson_id=${lessonId}&page_no=${pageNumber}&is_novel=1`
    )
      .then((response) => {
        const { result } = response
        setComments([...comments, ...result.lesson_comments])
        setPageNumber(result?.next_obj?.page_no)
        setIsFetching(false)
      })
      .catch((error) => {
        setIsFetching(false)
        throw error
      })
  }

  const handleCommentPost = () => {
    if (!user) {
      handlePostCommentLogoutUser()
      return
    }
    handleEventLog('writer_academy_lesson', 'button_click', {
      entity_type: 'lesson',
      entity_id: lessonId,
      module_name: 'comment',
    })
    const comment = commentValue.trim()
    if (!comment) return
    const postData = {
      lesson_id: lessonId?.toString(),
      comment: commentValue,
      comment_creator_uid: uid,
      fullname,
      gender,
      is_enable: true,
      entity_type: 'lesson',
      language: languages,
      profile_image_url: image_url,
    }
    post('/social/academy_comment.create?is_novel=1', {
      data: postData,
    })
      .then((res) => {
        setCommentValue('')
        const postedComment = res?.result?.comment_obj
        setComments([{ ...postedComment }, ...comments])
        // const h = commentsView?.current?.scrollHeight
        setTotalCommentsCount((totalCommentsCount) => totalCommentsCount + 1)
        isMobileView &&
          window.scroll({
            top: 0,
            behavior: 'smooth',
          })
      })
      .catch((err) => {
        throw err
      })
  }

  const getComments = () => {
    setIsLoading(true)
    get('/social/comment.get_academy_comments?is_novel=1', {
      params: {
        lesson_id: lessonId.toString(),
      },
    })
      .then((res) => {
        const { result } = res
        const commentsList = [...result?.lesson_comments]
        setTotalCommentsCount(result?.total_comments_count)
        setComments([...commentsList])
        setPageNumber(result?.next_obj?.page_no)
        setIsLoading(false)
      })
      .catch((err) => {
        setIsLoading(false)
        throw err
      })
  }

  useEffect(() => {
    getComments()
  }, [lessonId])

  useEffect(() => {
    if (isMobileView)
      window.scroll({
        top: 0,
        behavior: 'smooth',
      })
  }, [])

  const handleTextChange = (e) => {
    const val = e.target.value
    let trows = 0
    for (let i = 0; i < val.length; i++) {
      if (val.charAt(i) === '\n') trows++
    }
    setCommentValue(val)
    setTextareaheight(trows)
  }
  const handleBackCommentsScreen = () => {
    setCommentValue('')
    setIsCommentOpen(false)
  }

  if (!isMobileView)
    return (
      <DeskTopCommentsContainer>
        <Heading>{totalCommentsCount} Comments</Heading>
        <CommentContainer>
          <ImageContainer>
            <ProfileImage src={image_url} alt="Writer Avator" />
          </ImageContainer>
          <CommentWrapperforDesktop>
            <CommentTextArea
              name="comment_text"
              value={commentValue}
              rows={textareaheight}
              onChange={(e) => handleTextChange(e)}
            />
            <TelegramIconContainer onClick={() => handleCommentPost()}>
              <Telegram height="25px" width="25px" />
            </TelegramIconContainer>
          </CommentWrapperforDesktop>
        </CommentContainer>
        {comments?.map((commentInfo, index) => (
          <Comment {...commentInfo} keyName={index} />
        ))}
        {isFetching && <Loader />}
      </DeskTopCommentsContainer>
    )
  return (
    <>
      {isCommentOpen && (
        <MobileCommentsContainer>
          <MobileHeaderComments>
            <ArrowLeft
              width={25}
              height={25}
              onClick={() => handleBackCommentsScreen()}
            />
            Chapter Comments
          </MobileHeaderComments>
          {isLoading && <Loader />}
          {!!comments?.length && !isLoading && (
            <CommentsWrapper>
              {comments?.map((commentInfo, index) => (
                <Comment {...commentInfo} keyName={index} />
              ))}
              {isFetching && <Loader />}
            </CommentsWrapper>
          )}
          {!comments?.length && !isLoading && (
            <NoCommentContainer>
              <NoCommentWrapper>
                <EmptyComment />
                <NoCommentTitle>No Comments yet</NoCommentTitle>
                <NoCommentSubTitle>
                  Be the first one to comment on this episode.
                </NoCommentSubTitle>
              </NoCommentWrapper>
            </NoCommentContainer>
          )}
          <MobileFooterComments>
            <CommentTextAreaMobile
              name="comment_text"
              value={commentValue}
              rows={textareaheight}
              onChange={(e) => handleTextChange(e)}
            />
            <TelegramIconContainer onClick={() => handleCommentPost()}>
              <Telegram height="20px" width="20px" />
            </TelegramIconContainer>
          </MobileFooterComments>
        </MobileCommentsContainer>
      )}
    </>
  )
}
